import { JobList } from 'pages/common/job/JobList';
import React from 'react';

export const JobPosting: React.FC<any> = () => {
  return <JobList />;
};
